const handleDesignGuidePageFavorite = (userProfileObj) => {
  return (product) => {
    const newUserProfile = { ...userProfileObj };
    // step 1, determine whether the product already exists in the favorite rugs.
    const foundFavorite = newUserProfile.favorite_rugs.find((rug) => rug.productId === product.productId);

    if (foundFavorite) {
      // the favorite exists, so the user is trying to UN-favorite this product
      const indexOfFound = newUserProfile.favorite_rugs.indexOf(foundFavorite);
      newUserProfile.favorite_rugs.splice(indexOfFound, 1);
    } else {
      // the favorite does _not_ exist, and the user is trying add the product to
      // their favorite_rugs
      newUserProfile.favorite_rugs.unshift(product);
    }

    localStorage.setItem('user_profile', JSON.stringify(newUserProfile));
    localStorage.user_profile = JSON.stringify(newUserProfile);
    // Work around for current Navbar
    const navFavoriteCounter = document.getElementById('favs__counter');
    const navFavoriteIcon = document.getElementById('rug-nav-ul');
    const navfavoritesLi = document.getElementById('nav-favorites');

    if (newUserProfile.favorite_rugs.length <= 0) {
      navFavoriteIcon.classList.remove('fav-column');
      navFavoriteCounter.classList.add('d-none');
      navfavoritesLi.classList.add('d-none');
    }
    if (newUserProfile.favorite_rugs.length > 0) {
      navFavoriteIcon.classList.add('fav-column');
      navFavoriteCounter.classList.remove('d-none');
      navfavoritesLi.classList.remove('d-none');
      navFavoriteCounter.textContent = newUserProfile.favorite_rugs.length;
    }
  };
};

export class UserSession extends EventTarget {
  constructor() {
    super();
    this.setUserProfile();
    this.handleFavorite().bind(this);
  }

  setUserProfile() {
    const value = localStorage.getItem('user_profile');
    this.userProfile = JSON.parse(value);
  }

  handleFavorite(userProfile) {
    return (product) => {
      handleDesignGuidePageFavorite(userProfile)(product);
      this.setUserProfile();
      const event = new Event('change');
      this.dispatchEvent(event);
    };
  }
}

export const userSession = new UserSession();
